import { Grid, useMediaQuery } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import InvestmentProjectCard from '../../shared/components/investment-project/investment-project-card';
import { useEffect, useState } from 'react';
import ProjectCard from '../../shared/components/project-card';
import gaiaTheme from '../../theme';

const ProjectCarousel = (props) => {
  const [projects, setProjects] = useState([]);
  const [activeProjects, setActiveProjects] = useState([]);
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));

  const handleNext = () => {
    let newProjects = projects;
    const first = projects.splice(0, 1);
    newProjects.push(first[0]);
    setProjects(newProjects);
    setActiveProjects(projects.slice(0, 3));
  };

  const handlePrev = () => {
    let newProjects = projects;
    const first = projects.splice(projects.length - 1, projects.length);
    newProjects.unshift(first[0]);
    setProjects(newProjects);
    setActiveProjects(projects.slice(0, 3));
  };

  useEffect(() => {
    setProjects(props.investmentProjects ? props.investmentProjects : props.projects);
    setActiveProjects(props.investmentProjects ? props.investmentProjects.slice(0, 3) : props.projects.slice(0, 3));
  }, [props.investmentProjects, props.projects]);

  return (
    <Carousel
      navButtonsAlwaysVisible
      indicators={false}
      autoPlay={false}
      animation='slide'
      height='500px'
      sx={{ mt: 4 }}
      next={() => handleNext()}
      prev={() => handlePrev()}
    >
      <Grid container spacing={4} sx={{ pr: 2, pl: 2 }} >
        {activeProjects?.length > 0 && activeProjects?.map(project => (
          <Grid item xs={12} md={4} lg={4} key={project.id}>
            {props.investmentProjects && <InvestmentProjectCard
              id={project.id}
              title_text={project.title_text}
              subtitle_text={project.subtitle_text}
              description={project.description}
              primaryImageURL={project?.investment_project_images[0]?.location}
              shallow_status={project.shallow_status}
              un_goals={project.un_goals}
              investment_target={project.investment_target}
              externalProjectUrl={project.external_project_url}
              amountPledged={project.amount_pledged}
              comingSoon={project.coming_soon}
            />}

            {props.projects && <ProjectCard
              cardType="standard"
              id={project.p_id}
              summary={project.p_summary}
              description={project.p_description}
              primaryImage={project.project_images[0].key}
              primaryImageURL={project.project_images[0].location}
              location={project.p_location}
              LPA={project.p_local_planning_authority}
              NCA={project.p_national_character_area}
              totalBiodiversityUnits={project.totalBiodiversityUnitsRemaining}
              totalAreaHabitats={project.totalAreaHabitats}
              totalHedgerowHabitats={project.totalHedgerowHabitats}
              totalWatercourseHabitats={project.totalWatercourseHabitats}
              totalAreaPrice={project.totalAreaPrice}
              totalHedgerowPrice={project.totalHedgerowPrice}
              totalWatercoursePrice={project.totalWatercoursePrice}
              totalPrice={project.totalPrice}
              hidePrice={project.hidePrice}
              freeTier={project.freeTier}
              shallow_status={project.shallow_status}
              isMobileMode={isMobileMode}
              bngRegistered={project.bng_gov_registered}
              project={project}
            />}
          </Grid>
        ))}
      </Grid>
    </Carousel>
  );
};

export default ProjectCarousel;